import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "transferCard__head" }
const _hoisted_2 = { class: "transferCard__head__leftB" }
const _hoisted_3 = { class: "transferCard__head__type" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "transferCard__head__name" }, "Арнеда автомобиля", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "transferCard__head__rightB" }, [
  /*#__PURE__*/_createVNode("div", { class: "transferCard__head__info" }, "Яндекс такси"),
  /*#__PURE__*/_createVNode("div", { class: "transferCard__head__info" }, "Микроавтобус")
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.item.CarClass), 1),
      _hoisted_4
    ]),
    _hoisted_5
  ]))
}